import { Badge, cn } from "@tellescope/ui";
import { type ReactNode } from "react";
import { CLASSIFICATION_CLASS_NAMES } from "./styles";

export interface ClassificationCellProps {
  children: ReactNode;
  classification: string;
  className?: string;
}

export const ClassificationCell = ({ children, classification, className }: ClassificationCellProps) => {
  if (!classification.length) return null;

  return (
    <Badge variant="outline" className={cn("rounded-full", CLASSIFICATION_CLASS_NAMES[classification], className)}>
      {children}
    </Badge>
  );
};
